//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    article: {},
  },
  data() {
    return {
      row: {},
      typeOptions: [
        { label: 'Alternativ produktnummer', value: 0 },
        { label: 'Ean/Gtin', value: 1 },
        { label: 'Strekkkode', value: 2 }
      ],
      ean: "",
      barcodeType: "",
      quantity: 1, 
      barcodeId: 0,
      showDialog: false,
      busy: false,
      pagination: {
        page: 1,
        rowsPerPage: 10, 
      },
      columns: [
        {
          name: "ean",
          align: "left",
          label: "###",
          field: "ean",
        },
        {
          name: "barcodeType",
          align: "left",
          label: "Type",
          field: row => this.getTypeName(row.barcodeType),
        },
      ],
    };
  },
  methods: {

    getTypeName(barcodeType) {
      const option = this.typeOptions.find(option => option.value === barcodeType);
      return option ? option.label : ""; 
    },

    onCreateClick() {
      this.clearForm();
      this.showDialog = true;
    },

    onRowClick(evt, row) {
      this.row = row;
      this.ean = row.ean;
      this.barcodeType = row.barcodeType;
      this.quantity = row.quantity;
      this.barcodeId = row.id;
      this.showDialog = true;
    },

    async createOrUpdateBarcode() {
      var barcode = {};
      barcode.ean = this.ean;
      barcode.barcodeType = this.barcodeType;
      barcode.quantity = this.quantity;
      barcode.id = this.barcodeId;
      barcode.productId = this.article.id;

      if (barcode.id != 0) {
        // update
        var objIndex = this.article.barcodes.findIndex(
          (obj) => obj.id == barcode.id
        );
        this.$set(this.article.barcodes, objIndex, barcode);
      } else {
        //new
        barcode.id = Math.floor(Math.random() * -1000000 + 1); // hack to get a unique id.
        this.article.barcodes.push(barcode);
      }

      this.clearForm();
    },

    clearForm() {
      this.row = {};
      this.ean = "";
      this.quantity = 1;
      this.barcodeId = 0;
      this.showDialog = false;
    },

    async deleteClick() {
      this.article.barcodes = this.article.barcodes.filter(
        (barcode) => barcode.id !== this.barcodeId
      );
      this.clearForm();
    },
  },
};
